import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const DesignServicesModalContent: FC = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Box sx={(theme) => ({ height: 250, bgcolor: theme.palette.background.paper })}>
        <iframe
          src="https://media.changeengine.com/v/38877790-1492-44f9-9185-5f219d7e3ecb"
          title="video"
          width="100%"
          height="100%"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          style={{ border: "none" }}
        />
      </Box>
      <Typography sx={{ mt: 2 }} variant="body2">
        Design That Delivers More—With Less Lift.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "You’ve got access to top-tier design—why not tap into its full potential? More design support means more polish, more speed, and more wow in every project.",
        )}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "From branded guides to onboarding assets, event visuals to campaign creatives, you’ll get flawless, on-brand deliverables without the scramble. It’s the fastest way to go from getting by to standing out.",
        )}
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        Your brand deserves more than good—it deserves unforgettable.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Let’s unlock it.
      </Typography>
    </Box>
  );
};
